const getRoleDefaultDescription = (role)=>role.description;

export { getRoleDefaultDescription };
//# sourceMappingURL=getRoleDefaultDescription.mjs.map
